import Immutable from 'seamless-immutable';

import actions from './actions';

const initState = Immutable.from({
	staticPagesResponse: []
});

export default function staticPagesReducer(state = initState, { type, payload }) {
	switch (type) {
		case actions.STATIC_PAGES_SET: {
			return Immutable.set(state, 'staticPagesResponse', payload.staticPages);
		}
		default: {
			return state;
		}
	}
}
